import styled from 'styled-components';
import {Paper} from "@material-ui/core";

export const CardContainer = styled(Paper)`
    border-radius: 8px;
    padding: 16px;
    text-align: center;
`;

export const CardTitle = styled.h3`
    color: #3f3f3f;
    font-size: 14px;
    margin: 0;
`;

export const CardTotal = styled.p`
    color: ${'#' + process.env.REACT_APP_PRIMARY_COLOR};
    font-size: 1.8em;
    font-weight: bold;
    margin: 0;
`;

export const ContentParentTotalizeStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContentContainerTotalizeStyled = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    gap: 16px;

    flex-direction: row;
`;

export const ContentContainerChartStyled = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
